// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1QZTa","bigColWidth":"Table_bigColWidth__3GofQ","biggerColWidth":"Table_biggerColWidth__30XIS","row":"Table_row__3cmZC","col":"Table_col__3fCaO"};